import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import BlogMain from '../components/sections/BlogMain';

const Blog = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.blog.title" subtitleKey="sections.breadcrumb.blog.subtitle" />
        <BlogMain />
      <Footer />
    </>
  );
};

export default Blog;